import { createFeatureSelector, createSelector } from '@ngrx/store';
import { State } from '../reducers';
import * as fromTeamleader from '../reducers/teamleader.reducer';

export const getTeamleader = createFeatureSelector<State, fromTeamleader.State>('teamleader');

export const getTeamleaderCalendar = createSelector(getTeamleader, (state) => state.calendar);
